import { render, staticRenderFns } from "./g-image-user.vue?vue&type=template&id=da37298c&"
import script from "./g-image-user.vue?vue&type=script&lang=js&"
export * from "./g-image-user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports